import React from "react";
import Text from "../../contentBlocks/Text.react";
import SlideHeader from "../../contentBlocks/SlideHeader.react";
import { Button } from "config/initializers/styles.app";
import { Image } from "semantic-ui-react";
import _ from "lodash";

import { getAppConfig } from "config/client.config";
import { resolveImage } from "config/app.helpers";
import { Translations } from "config/app.translations";
import { VelocityTransitionGroup } from "velocity-react";
import PropTypes from "prop-types";
import SlideHeaderSidebar from "../../contentBlocks/SlideHeaderSidebar.react";

import { Grid } from "semantic-ui-react";

export default class PictureFuddle extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            answer: "",
            filter: this.props.data.filter,
        };
    }

    static propTypes = {
        data: PropTypes.shape({
            title: PropTypes.string,
            filter: PropTypes.string,
            subtitle: PropTypes.string,
            question: PropTypes.string,
            answer: PropTypes.string,
            purpose: PropTypes.string,
            imageLibrary: PropTypes.array,
        }).isRequired,
        colors: PropTypes.shape({
            baseText: PropTypes.string.isRequired,
        }).isRequired,
        slideId: PropTypes.number,
        trackInteraction: PropTypes.func.isRequired,
        mobileView: PropTypes.bool,
    };

    static defaultProps = {
        mobileView: false,
    };

    handleClick = () => {
        this.props.trackInteraction(this.state.answer);
    };

    changeText = (event) => {
        this.setState({ answer: event.target.value });
    };

    render() {
        let isPortrait =
            this.props.mobileView || window.innerHeight > window.innerWidth;
        let defaultStyle = {
            margin: "auto",
            width: "100%",
            height: "100%",
            textAlign: "center",
            position: "relative",
            zIndex: "1",
            //overflow: "hidden"
        };
        let defaultLandscapeStyle = {
            margin: "auto",
            width: "100%",
            textAlign: "center",
            height: "100%",
            position: "relative",
            float: "right",
            //overflow: "hidden"
        };
        let questionSectionStyle = {
            width: "90%",
            margin: isPortrait ? "25px auto" : "5px auto",
        };
        let buttonStyle = {
            marginTop: "5px",
        };
        let imageStyle = {
            position: "relative",
            left: "0",
            width: "100%",
            marginBottom: "20px",
        };
        let imagePortraitStyle = {};
        let answer = this.props.data.answer
            .toString()
            .trim()
            .replace(/[a-z0-9&_]/gi, "*");
        let templateTranslations = _.find(Translations, {
            language: "en",
        }).templateActions;
        let title =
            this.props.data.header !== undefined
                ? this.props.data.header
                : this.props.data.title;
        let subtitle =
            this.props.data.subheader !== undefined
                ? this.props.data.subheader
                : this.props.data.subtitle;
        return (
            <div className="full-height">
                {isPortrait && (
                    <SlideHeader
                        {...this.props}
                        title={title}
                        subtitle={subtitle}
                    />
                )}
                {isPortrait && (
                    <div style={defaultStyle}>
                        <div style={imagePortraitStyle}>
                            <Image
                                src={resolveImage(
                                    this.props.data.image === undefined
                                        ? this.props.data.images
                                        : this.props.data.image.id,
                                    this.props.imageLibrary
                                )}
                                className={this.props.data.filter}
                                fluid={true}
                            />
                        </div>
                        <div style={questionSectionStyle}>
                            <Text
                                keyName={"question-" + this.props.slideId}
                                text={this.props.data.question}
                                color={this.props.colors.baseText}
                                fontSize="large"
                                animation="transition.bounceUpIn,500,1000"
                            />
                            <br />
                            <VelocityTransitionGroup
                                enter={{
                                    animation: "transition.bounceUpIn",
                                    duration: "500",
                                    delay: "1500",
                                }}
                                leave={{ animation: "fadeOut", duration: "0" }}
                                runOnMount
                            >
                                <input
                                    type="text"
                                    placeholder={answer}
                                    style={getAppConfig().textInputStyle}
                                    onChange={this.changeText}
                                />
                                <br />
                                <Button
                                    style={buttonStyle}
                                    onClick={this.handleClick}
                                >
                                    {this.props.data.purpose === "quiz"
                                        ? templateTranslations.checkAnswer
                                        : templateTranslations.submitAnswer}
                                </Button>
                            </VelocityTransitionGroup>
                        </div>
                    </div>
                )}
                {!isPortrait && (
                    <Grid style={{ minHeight: "100%" }}>
                        <Grid.Row style={{ paddingBottom: "0" }}>
                            <Grid.Column
                                width={8}
                                style={{
                                    paddingRight: "0",
                                    backgroundColor: this.props.colors.primary,
                                }}
                            >
                                <SlideHeaderSidebar
                                    {...this.props}
                                    title={title}
                                    subtitle={subtitle}
                                />
                            </Grid.Column>
                            <Grid.Column
                                width={8}
                                style={{
                                    paddingLeft: "0",
                                    paddingBottom: "3%",
                                }}
                            >
                                <div style={defaultLandscapeStyle}>
                                    <div style={imageStyle}>
                                        <Image
                                            src={resolveImage(
                                                this.props.data.image ===
                                                    undefined
                                                    ? this.props.data.images
                                                    : this.props.data.image.id,
                                                this.props.imageLibrary
                                            )}
                                            className={this.props.data.filter}
                                            fluid={true}
                                        />
                                    </div>
                                    <div style={questionSectionStyle}>
                                        <Text
                                            keyName={
                                                "question-" + this.props.slideId
                                            }
                                            text={this.props.data.question}
                                            color={this.props.colors.baseText}
                                            fontSize="large"
                                            animation="transition.bounceUpIn,500,1000"
                                        />
                                        <br />
                                        <VelocityTransitionGroup
                                            enter={{
                                                animation:
                                                    "transition.bounceUpIn",
                                                duration: "500",
                                                delay: "1500",
                                            }}
                                            leave={{
                                                animation: "fadeOut",
                                                duration: "0",
                                            }}
                                            runOnMount
                                        >
                                            <input
                                                type="text"
                                                placeholder={answer}
                                                style={
                                                    getAppConfig()
                                                        .textInputStyle
                                                }
                                                onChange={this.changeText}
                                            />
                                            <br />
                                            <Button
                                                style={buttonStyle}
                                                onClick={this.handleClick}
                                            >
                                                {this.props.data.purpose ===
                                                "quiz"
                                                    ? templateTranslations.checkAnswer
                                                    : templateTranslations.submitAnswer}
                                            </Button>
                                        </VelocityTransitionGroup>
                                    </div>
                                </div>
                            </Grid.Column>
                        </Grid.Row>
                    </Grid>
                )}
            </div>
        );
    }
}
